import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-why-choose-us',
  templateUrl: './why-choose-us.component.html',
  styleUrls: ['./why-choose-us.component.css']
})
export class WhyChooseUsComponent implements OnInit {

  constructor(private meta: Meta, private title: Title) { }

  ngOnInit(): void {
    this.metaTagAdd()  //////  Meta tags add for SEO  //////
  }
  metaTagAdd() {
    this.title.setTitle('Budget Friendly Temple Travel for Seniors India');

    this.meta.updateTag({
      name: 'description',
      content: 'Explore Kedarnath Badrinath Tour Itineraries, Spiritual Travel Packages India and Spiritual Travel Packages with Multilingual Guides with My Yatra360.'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'Budget Friendly Temple Travel for Seniors India, Kedarnath Badrinath Tour Itineraries, Spiritual Travel Packages India, Spiritual Travel Packages with Multilingual Guides'
    });
  }
}
